import { render, staticRenderFns } from "./validate.vue?vue&type=template&id=991013c4&scoped=true&"
import script from "./validate.vue?vue&type=script&lang=js&"
export * from "./validate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "991013c4",
  null
  
)

export default component.exports